var classes = {"globalBanner":"ZYZKS","inlineLink":"upHNF"};

export { classes as default };
